import { AgencyOperationsAdminHomeLinkCards } from "src/components/agency/operations/administrator/AgencyOperationsAdminHomeLinkCards"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"

export const AgencyOperationsAdminHome = () => {
 
    const userName = useAppState(state=>state.user_name)

    return (
        <PageLayout
            header={<PageHeader
                title={`Welcome ${userName}`}
            />
        }>
            <AgencyOperationsAdminHomeLinkCards/>
        </PageLayout>
    )
} 